/** An itinerary's status chip (plan §2): a neutral outlined chip with the status's icon and
 *  word — **Live** / **Coming soon** / **Not published** / **Placeholder**, never "Draft".
 *  The record header and the itineraries grid both render it, so a status never reads two
 *  ways (One-Wording); `data-*` props pass through to the chip. */
import CropFreeIcon from '@mui/icons-material/CropFree';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Chip, type ChipProps, type SvgIconProps } from '@mui/material';
import type { ComponentType } from 'react';

import { CATALOG_STATUS_LABEL, type CatalogStatus } from './words';

export const CATALOG_STATUS_ICON: Readonly<Record<CatalogStatus, ComponentType<SvgIconProps>>> = {
  live: VisibilityOutlinedIcon,
  coming_soon: ScheduleOutlinedIcon,
  not_published: VisibilityOffOutlinedIcon,
  placeholder: CropFreeIcon,
};

export function CatalogStatusChip({
  status,
  ...rest
}: { status: CatalogStatus } & Omit<ChipProps, 'icon' | 'label' | 'size' | 'variant' | 'color'>) {
  const Icon = CATALOG_STATUS_ICON[status];
  return (
    <Chip
      size="small"
      variant="outlined"
      icon={<Icon />}
      label={CATALOG_STATUS_LABEL[status]}
      {...rest}
    />
  );
}
